import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const swatches = [
  { name: 'Noir mat', bg: 'bg-[#1a1a1a]' },
  { name: 'Ardoise', bg: 'bg-[#3d4f5f]' },
  { name: 'Vert forêt', bg: 'bg-[#2d4a3e]' },
  { name: 'Brun chocolat', bg: 'bg-[#4a3b2a]' },
  { name: 'Bleu profond', bg: 'bg-[#1e3a5f]' },
  { name: 'Rouge tuile', bg: 'bg-[#8b3a2a]' },
  { name: 'Sable', bg: 'bg-[#b8a88a]' },
  { name: 'Blanc', bg: 'bg-[#f5f5f5] border border-gray-200' },
];

export default function Couleurs() {
  const { t } = useTranslation('tole');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="couleurs" className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-10 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl mb-3">
            {t('couleurs_h2')}
          </h2>
        </div>

        <div
          className={`grid grid-cols-4 sm:grid-cols-4 lg:grid-cols-8 gap-4 md:gap-5 mb-8 transition-all duration-1000 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {swatches.map((swatch, idx) => (
            <div
              key={idx}
              className="text-center transition-all duration-700"
              style={{ transitionDelay: `${idx * 80 + 200}ms` }}
            >
              <div
                className={`w-full aspect-square rounded-xl ${swatch.bg} mb-2 shadow-sm`}
              />
              <span className="text-slate-primary text-xs font-medium">{swatch.name}</span>
            </div>
          ))}
        </div>

        <p
          className={`text-center text-slate-primary/50 text-xs md:text-sm max-w-2xl mx-auto transition-all duration-1000 delay-300 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {t('couleurs_note')}
        </p>
      </div>
    </section>
  );
}